import { AnyAction } from 'redux';
import { createEpicMiddleware } from 'redux-observable';

import { RootState } from '../rootState.d';

const epicMiddleware = createEpicMiddleware<AnyAction, AnyAction, RootState>();

export default epicMiddleware;
